import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "../../../common/components/Toast";
import { createReportTemplate } from "../../api/report-templates";

export default function CreateReportTemplate() {
  const navigate = useNavigate();

  useEffect(() => {
    const createUntitledTemplate = async () => {
      try {
        const newTemplate = await createReportTemplate({
          title: "Untitled Report",
          // Section toggles
          include_project_summary: true,
          include_asset_breakdown: true,
          // Project summary columns
          include_total_assets: true,
          include_total_impressions: true,
          include_total_royalty_revenue: true,
          include_total_impression_revenue: true,
          include_total_revenue: true,
          // Asset breakdown columns
          include_sales_revenue: true,
          include_impressions: true,
          include_impressions_revenue: true,
        });
        // Redirect to edit page with the new template ID
        navigate(`/report-templates/${newTemplate.id}`, { replace: true });
      } catch (error) {
        toast.error("Failed to create template.");
        navigate("/report-templates");
      }
    };

    createUntitledTemplate();
  }, [navigate]);

  return <div>Creating template...</div>;
}
